// This file is auto-generated by @hey-api/openapi-ts

import { formDataBodySerializer } from './client';
import { client } from './Client.gen';
import type { EshopCardApplicationControllerCreateBankCardApplicationData } from './EshopCardApplicationControllerCreateBankCardApplicationData.gen';
import type { EshopCardApplicationControllerCreateBankCardApplicationErrors } from './EshopCardApplicationControllerCreateBankCardApplicationErrors.gen';
import type { EshopCardApplicationControllerCreateBankCardApplicationResponses } from './EshopCardApplicationControllerCreateBankCardApplicationResponses.gen';
import type { EshopCardApplicationControllerCreateData } from './EshopCardApplicationControllerCreateData.gen';
import type { EshopCardApplicationControllerCreateErrors } from './EshopCardApplicationControllerCreateErrors.gen';
import type { EshopCardApplicationControllerCreateExternalCardApplicationData } from './EshopCardApplicationControllerCreateExternalCardApplicationData.gen';
import type { EshopCardApplicationControllerCreateExternalCardApplicationErrors } from './EshopCardApplicationControllerCreateExternalCardApplicationErrors.gen';
import type { EshopCardApplicationControllerCreateExternalCardApplicationResponses } from './EshopCardApplicationControllerCreateExternalCardApplicationResponses.gen';
import type { EshopCardApplicationControllerCreateResponses } from './EshopCardApplicationControllerCreateResponses.gen';
import type { EshopCardApplicationControllerCreateVirtualCardApplicationData } from './EshopCardApplicationControllerCreateVirtualCardApplicationData.gen';
import type { EshopCardApplicationControllerCreateVirtualCardApplicationErrors } from './EshopCardApplicationControllerCreateVirtualCardApplicationErrors.gen';
import type { EshopCardApplicationControllerCreateVirtualCardApplicationResponses } from './EshopCardApplicationControllerCreateVirtualCardApplicationResponses.gen';
import type { EshopCardApplicationControllerCreateVirtualCardApplicationWithAccountData } from './EshopCardApplicationControllerCreateVirtualCardApplicationWithAccountData.gen';
import type { EshopCardApplicationControllerCreateVirtualCardApplicationWithAccountErrors } from './EshopCardApplicationControllerCreateVirtualCardApplicationWithAccountErrors.gen';
import type { EshopCardApplicationControllerCreateVirtualCardApplicationWithAccountResponses } from './EshopCardApplicationControllerCreateVirtualCardApplicationWithAccountResponses.gen';
import type { EshopCardApplicationControllerGetCardApplicationsData } from './EshopCardApplicationControllerGetCardApplicationsData.gen';
import type { EshopCardApplicationControllerGetCardApplicationsErrors } from './EshopCardApplicationControllerGetCardApplicationsErrors.gen';
import type { EshopCardApplicationControllerGetCardApplicationsResponses } from './EshopCardApplicationControllerGetCardApplicationsResponses.gen';
import type { EshopCardApplicationControllerGetHasCardApplicationFeeData } from './EshopCardApplicationControllerGetHasCardApplicationFeeData.gen';
import type { EshopCardApplicationControllerGetHasCardApplicationFeeErrors } from './EshopCardApplicationControllerGetHasCardApplicationFeeErrors.gen';
import type { EshopCardApplicationControllerGetHasCardApplicationFeeResponses } from './EshopCardApplicationControllerGetHasCardApplicationFeeResponses.gen';
import type { EshopCardApplicationControllerGetLastData } from './EshopCardApplicationControllerGetLastData.gen';
import type { EshopCardApplicationControllerGetLastErrors } from './EshopCardApplicationControllerGetLastErrors.gen';
import type { EshopCardApplicationControllerGetLastResponses } from './EshopCardApplicationControllerGetLastResponses.gen';
import type { EshopCardApplicationControllerGetOneData } from './EshopCardApplicationControllerGetOneData.gen';
import type { EshopCardApplicationControllerGetOneErrors } from './EshopCardApplicationControllerGetOneErrors.gen';
import type { EshopCardApplicationControllerGetOneResponses } from './EshopCardApplicationControllerGetOneResponses.gen';
import type { EshopCardApplicationControllerRejectData } from './EshopCardApplicationControllerRejectData.gen';
import type { EshopCardApplicationControllerRejectErrors } from './EshopCardApplicationControllerRejectErrors.gen';
import type { EshopCardApplicationControllerRejectResponses } from './EshopCardApplicationControllerRejectResponses.gen';
import type { EshopCardApplicationControllerUploadAttachmentData } from './EshopCardApplicationControllerUploadAttachmentData.gen';
import type { EshopCardApplicationControllerUploadAttachmentErrors } from './EshopCardApplicationControllerUploadAttachmentErrors.gen';
import type { EshopCardApplicationControllerUploadAttachmentResponses } from './EshopCardApplicationControllerUploadAttachmentResponses.gen';
import type { EshopCardApplicationControllerValidateExternalCardNumberData } from './EshopCardApplicationControllerValidateExternalCardNumberData.gen';
import type { EshopCardApplicationControllerValidateExternalCardNumberErrors } from './EshopCardApplicationControllerValidateExternalCardNumberErrors.gen';
import type { EshopCardApplicationControllerValidateExternalCardNumberResponses } from './EshopCardApplicationControllerValidateExternalCardNumberResponses.gen';
import type { EshopCardApplicationControllerVerifyIfCardCanBeSendByPostData } from './EshopCardApplicationControllerVerifyIfCardCanBeSendByPostData.gen';
import type { EshopCardApplicationControllerVerifyIfCardCanBeSendByPostErrors } from './EshopCardApplicationControllerVerifyIfCardCanBeSendByPostErrors.gen';
import type { EshopCardApplicationControllerVerifyIfCardCanBeSendByPostResponses } from './EshopCardApplicationControllerVerifyIfCardCanBeSendByPostResponses.gen';
import type { Options } from './Options.gen';

export class EshopCardApplicationController {
    /**
     * Get card application list for the given customer.
     *
     * Field `stateIds` must be send as stateIds[]=value.
     */
    public static getCardApplications<ThrowOnError extends boolean = false>(options?: Options<EshopCardApplicationControllerGetCardApplicationsData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCardApplicationControllerGetCardApplicationsResponses, EshopCardApplicationControllerGetCardApplicationsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/card-applications',
            ...options
        });
    }
    
    /**
     * Create card application.
     *
     * If an origin customer is passed to the application, Bad Request error `InvalidCustomer` is returned.<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_CUSTOMER** - Customer does not exist, belongs to another account, is a draft or origin.<br>
     * + **INVALID_CUSTOMER_PROFILE** - Customer profile does not exist, is not valid for the customer, is impersonal, is not primary or has invalid properties combination.<br>
     * + **INVALID_DELIVERY_OPTION** - At least one type of delivery must be set<br>
     * + **INVALID_BRANCH_OFFICE** - Branch office does not exist.<br>
     * + **INVALID_PROFILE_VALID_FROM** - Profile ValidFrom is required or is not in card application validFrom-validTo range.<br>
     * + **INVALID_PROFILE_VALID_TO** - Profile ValidTo is required or is not in card application validFrom-validTo range.<br>
     * + **INVALID_VALID_TO** - Valid to must be bigger than valid from or is in the past.
     */
    public static create<ThrowOnError extends boolean = false>(options: Options<EshopCardApplicationControllerCreateData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCardApplicationControllerCreateResponses, EshopCardApplicationControllerCreateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/card-applications',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get last card application.
     */
    public static getLast<ThrowOnError extends boolean = false>(options?: Options<EshopCardApplicationControllerGetLastData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCardApplicationControllerGetLastResponses, EshopCardApplicationControllerGetLastErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/card-applications/last',
            ...options
        });
    }
    
    /**
     * Check if card application has fee.
     */
    public static getHasCardApplicationFee<ThrowOnError extends boolean = false>(options?: Options<EshopCardApplicationControllerGetHasCardApplicationFeeData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCardApplicationControllerGetHasCardApplicationFeeResponses, EshopCardApplicationControllerGetHasCardApplicationFeeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/card-applications/has-fee',
            ...options
        });
    }
    
    /**
     * Get card application.
     */
    public static getOne<ThrowOnError extends boolean = false>(options: Options<EshopCardApplicationControllerGetOneData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCardApplicationControllerGetOneResponses, EshopCardApplicationControllerGetOneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/card-applications/{id}',
            ...options
        });
    }
    
    /**
     * Create a virtual card application and account.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **USERNAME_NOT_UNIQUE** - Username already exists.<br>
     * + **CUSTOMER_ALREADY_HAS_REGISTERED_ACCOUNT** - Customer already has a registered account.<br>
     * + **CUSTOMER_TOO_YOUNG_TO_CREATE_REGISTERED_ACCOUNT** - Customer is not able register to eshop account (too young).<br>
     * + **CUSTODIAN_IS_REQUIRED** - Custodian is required for customer under the age of 15.<br>
     * + **INVALID_CUSTOMER_CARD_TYPE** - Customer card can not be this type.<br>
     * + **INVALID_CUSTOMER** - Customer does not exist, belongs to another account, is a draft or origin.<br>
     * + **INVALID_CUSTOMER_PROFILE** - Customer profile does not exist, is not valid for the customer, is impersonal, is not primary or has invalid properties combination.<br>
     * + **CUSTOMER_ALREADY_HAS_ACTIVE_CARD_APPLICATION** - Customer already has active card application.<br>
     * + **CUSTOMER_HAS_CARD_TO_BE_ISSUED** - The customer has a card in state "IN_PROGRESS" or "NOT_ISSUED".<br>
     * + **ISIC_NUMBER_IS_REQUIRED** - The ISIC number is mandatory in combination with a customer profile with allowed isic.<br>
     * + **ISIC_NOT_ALLOWED** - Isic is not allowed in system configuration.<br>
     * + **MULTIPLE_CUSTOMER_PROFILES_WITH_ISIC** - Multiple ISIC discount profiles on a card are not allowed.<br>
     * + **ISIC_CARD_NUMBER_ALREADY_USED** - Isic card number is already used in the system.<br>
     * + **ISIC_CARD_NUMBER_NOT_VALID** - Isic card number is not valid for customer and discount.
     */
    public static createVirtualCardApplicationWithAccount<ThrowOnError extends boolean = false>(options: Options<EshopCardApplicationControllerCreateVirtualCardApplicationWithAccountData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCardApplicationControllerCreateVirtualCardApplicationWithAccountResponses, EshopCardApplicationControllerCreateVirtualCardApplicationWithAccountErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/card-applications/virtual-with-account',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create external card application.
     *
     * If an origin customer is passed to the application, Bad Request error `InvalidCustomer` is returned.<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **INVALID_CUSTOMER_CARD_TYPE** - Customer card can not be this type.<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_EXTERNAL_CARD_NUMBER** - External card number is invalid. Card number must be a valid Luhn number.<br>
     * + **BLOCKED_EXTERNAL_CARD** - External card number is blocked<br>
     * + **CARD_APPLICATION_NOT_MODIFIABLE** - Card application cannot be changed, because it's already processed.<br>
     * + **INVALID_PROFILE_VALID_TO** - Profile ValidTo is required or is not in card application validFrom-validTo range.<br>
     * + **INVALID_PROFILE_VALIDITY** - Customer profile does not exist or is not in card validFrom-validTo range.<br>
     * + **CUSTOMER_PROFILES_COLLISION** - Customer profiles validFrom-validTo ranges are in collision.<br>
     * + **ISIC_NUMBER_IS_REQUIRED** - The ISIC number is mandatory in combination with a customer profile with allowed isic.<br>
     * + **ISIC_NOT_ALLOWED** - Isic is not allowed in system configuration.<br>
     * + **MULTIPLE_CUSTOMER_PROFILES_WITH_ISIC** - Multiple ISIC discount profiles on a card are not allowed.<br>
     * + **ISIC_CARD_NUMBER_ALREADY_USED** - Isic card number is already used in the system.<br>
     * + **ISIC_CARD_NUMBER_NOT_VALID** - Isic card number is not valid for customer and discount.<br>
     * + **CUSTOMER_ALREADY_HAS_ACTIVE_CARD_APPLICATION** - Customer already has active card application.<br>
     * + **CUSTOMER_HAS_CARD_TO_BE_ISSUED** - The customer has a card in state "IN_PROGRESS" or "NOT_ISSUED".<br>
     * + **CARD_NUMBER_NOT_UNIQUE** - Card number already exists.<br>
     * + **CHIP_NUMBER_NOT_UNIQUE** - Chip number already exists.
     */
    public static createExternalCardApplication<ThrowOnError extends boolean = false>(options: Options<EshopCardApplicationControllerCreateExternalCardApplicationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCardApplicationControllerCreateExternalCardApplicationResponses, EshopCardApplicationControllerCreateExternalCardApplicationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/card-applications/external',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Validate external card number.
     *
     * Validate against blocked card and luhn algorithm<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **INVALID_EXTERNAL_CARD_NUMBER** - External card number is invalid. Card number must be a valid Luhn number.<br>
     * + **BLOCKED_EXTERNAL_CARD** - External card number is blocked
     */
    public static validateExternalCardNumber<ThrowOnError extends boolean = false>(options: Options<EshopCardApplicationControllerValidateExternalCardNumberData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCardApplicationControllerValidateExternalCardNumberResponses, EshopCardApplicationControllerValidateExternalCardNumberErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/card-applications/external/validate',
            ...options
        });
    }
    
    /**
     * Check if card can be send by post.
     */
    public static verifyIfCardCanBeSendByPost<ThrowOnError extends boolean = false>(options: Options<EshopCardApplicationControllerVerifyIfCardCanBeSendByPostData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCardApplicationControllerVerifyIfCardCanBeSendByPostResponses, EshopCardApplicationControllerVerifyIfCardCanBeSendByPostErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/card-applications-delivery-check',
            ...options
        });
    }
    
    /**
     * Create a virtual card application.
     *
     * If an origin customer is passed to the application, Bad Request error `InvalidCustomer` is returned.<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_CUSTOMER** - Customer does not exist, belongs to another account, is a draft or origin.<br>
     * + **INVALID_CUSTOMER_PROFILE** - Customer profile does not exist, is not valid for the customer, is impersonal, is not primary or has invalid properties combination.<br>
     * + **INVALID_PROFILE_VALID_FROM** - Profile ValidFrom is required or is not in card application validFrom-validTo range.<br>
     * + **INVALID_PROFILE_VALID_TO** - Profile ValidTo is required or is not in card application validFrom-validTo range.<br>
     * + **INVALID_VALID_TO** - Valid to must be bigger than valid from or is in the past.<br>
     * + **CUSTOMER_ALREADY_HAS_ACTIVE_CARD_APPLICATION** - Customer already has active card application.
     */
    public static createVirtualCardApplication<ThrowOnError extends boolean = false>(options: Options<EshopCardApplicationControllerCreateVirtualCardApplicationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCardApplicationControllerCreateVirtualCardApplicationResponses, EshopCardApplicationControllerCreateVirtualCardApplicationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/card-applications-virtual',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create a bank card application.
     *
     * If an origin customer is passed to the application, Bad Request error `InvalidCustomer` is returned.<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_CUSTOMER** - Customer does not exist, belongs to another account, is a draft or origin.<br>
     * + **INVALID_CUSTOMER_PROFILE** - Customer profile does not exist, is not valid for the customer, is impersonal, is not primary or has invalid properties combination.<br>
     * + **INVALID_PROFILE_VALID_FROM** - Profile ValidFrom is required or is not in card application validFrom-validTo range.<br>
     * + **INVALID_PROFILE_VALID_TO** - Profile ValidTo is required or is not in card application validFrom-validTo range.<br>
     * + **INVALID_VALID_TO** - Valid to must be bigger than valid from or is in the past.<br>
     * + **CUSTOMER_ALREADY_HAS_ACTIVE_CARD_APPLICATION** - Customer already has active card application.
     */
    public static createBankCardApplication<ThrowOnError extends boolean = false>(options: Options<EshopCardApplicationControllerCreateBankCardApplicationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCardApplicationControllerCreateBankCardApplicationResponses, EshopCardApplicationControllerCreateBankCardApplicationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/card-applications-bank',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Reject a card application.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **CARD_APPLICATION_NOT_MODIFIABLE** - Card application cannot be changed, because it's already processed.
     */
    public static reject<ThrowOnError extends boolean = false>(options: Options<EshopCardApplicationControllerRejectData, ThrowOnError>) {
        return (options.client ?? client).put<EshopCardApplicationControllerRejectResponses, EshopCardApplicationControllerRejectErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/card-applications/{id}/reject',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Add attachment to card application.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_CUSTOMER** - Customer does not exist, belongs to another account, is a draft or origin.<br>
     * + **INVALID_CUSTOMER_PROFILE** - Customer profile does not exist, is not valid for the customer, is impersonal, is not primary or has invalid properties combination.<br>
     * + **INVALID_PROFILE_VALID_FROM** - Profile ValidFrom is required or is not in card application validFrom-validTo range.<br>
     * + **INVALID_PROFILE_VALID_TO** - Profile ValidTo is required or is not in card application validFrom-validTo range.<br>
     * + **INVALID_VALID_TO** - Valid to must be bigger than valid from or is in the past.<br>
     * + **CUSTOMER_ALREADY_HAS_ACTIVE_CARD_APPLICATION** - Customer already has active card application.
     */
    public static uploadAttachment<ThrowOnError extends boolean = false>(options: Options<EshopCardApplicationControllerUploadAttachmentData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCardApplicationControllerUploadAttachmentResponses, EshopCardApplicationControllerUploadAttachmentErrors, ThrowOnError>({
            ...formDataBodySerializer,
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/card-applications/{id}/attachment',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
}
